import React from "react";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

// Un solo boton para todas las descargas de un listado (PDF, Excel, Excel por
// talla y color, correo...). Antes cada listado traia cuatro o cinco botones
// sueltos arriba; aqui van todos juntos y la pantalla queda limpia.
//
//   <MenuDescargas opciones={[{ label: "PDF", icon: "fas fa-file-pdf", onClick: pdf }]} />
function MenuDescargas({ opciones = [], titulo = "Descargas", color = "danger", size = "sm" }) {
  const visibles = opciones.filter((o) => o && !o.oculto);
  if (!visibles.length) return null;
  return (
    <UncontrolledDropdown style={{ display: "inline-block" }}>
      <DropdownToggle size={size} color={color} caret id="botonListado">
        <i className="fas fa-download" /> {titulo}
      </DropdownToggle>
      {/* pegado a la derecha: se abre hacia adentro para no salirse */}
      <DropdownMenu right>
        {visibles.map((o, i) =>
          o.separador ? (
            <DropdownItem divider key={i} />
          ) : (
            <DropdownItem key={i} onClick={o.onClick} disabled={o.deshabilitado}>
              {o.icon ? <i className={o.icon} style={{ width: 18 }} /> : null} {o.label}
            </DropdownItem>
          )
        )}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}

export default MenuDescargas;
